/* eslint-disable react-hooks/exhaustive-deps */

import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { isEmpty, cloneDeep, replace, capitalize, set, isArray } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import * as action from '../store/CustomSections.action';
import * as devOrderAction from '../../../DevlopmentOrder/store/DevelopmentOrder.action';
import * as Action from '../../../SystemMasters/Store/SystemMasters.action';

export const StateContext = createContext(null);

export default function CustomColumnContextProvider({ children, ...props }) {
  const initialSetting = {
    columns: [
      {
        columnType: null,
        title: '',
      },
    ],
    columnOptionsArr: [
      {
        name: 'calculation',
        _id: 'Calculation',
      },
      {
        name: 'manual',
        _id: 'Manual',
      },
      {
        name: 'source',
        _id: 'Source',
      },
    ],
    isEditMode: false,
  };
  const staticCalcObj = {
    location: null,
    subLocation: null,
    calcSymbol: null,
  };
  const reduxData = useSelector((prevState) => prevState);
  const thisFieldisRequired = 'This field is required';
  const {
    customSectionData: { editColumnData },
  } = reduxData;
  const dispatch = useDispatch();

  const [customColumnState, setCustomColumnState] = useState(initialSetting);
  const [globalError, setGlobalErrors] = useState({});
  const ecomApiCall = async () => {
    const ecomValues = await dispatch(devOrderAction.getEcommSpec('eCommSpec'));
    if (ecomValues?.isActive) {
      await dispatch(Action.getMeasurementDetails({ isActive: true }));
    }
  };

  useEffect(() => {
    if (!isEmpty(editColumnData)) {
      const editData = cloneDeep(editColumnData);
      if (editData?.type) {
        editData.type = {
          type: replace(editData?.type, '_', ' '),
          name: editData?.type,
        };
      }
      editData.columnType = {
        name: editData?.columnType || 'manual',
        _id: capitalize(editData?.columnType) || 'Manual',
      };
      if (editData?.source?.location?.name === 'Measurement_Information' || editData?.source?.subLocation?.name === 'ecomSpec') {
        ecomApiCall();
      }
      setCustomColumnState((prevState) => ({
        ...prevState,
        columns: [editData],
        isEditMode: true,
      }));
    }
  }, [editColumnData]);

  const validateFields = {
    source: ['location', 'subLocation', 'locationType', 'locationPlacement', 'attribute', 'output'],
    formulaArr: ['location', 'subLocation'],
    options: ['name'],
    common: ['columnType', 'title', 'formulaString'],
    manual: ['type', 'characterLimit'],
  };

  const checkValidation = () => {
    const fieldError = globalError;
    const copyState = customColumnState;
    let hasErrors = false;
    const columns = copyState?.columns || [];

    for (const [pindex, col] of columns.entries()) {
      Object.keys(validateFields)?.forEach((key) => {
        // Removed async from here
        switch (key) {
          case 'source':
            if (col?.columnType?.name === 'source') {
              validateFields[key]?.forEach((fieldKey) => {
                if (
                  col[key]?.location?.name === 'Measurement_Information' &&
                  col[key]?.subLocation?.name === 'ecomSpec' &&
                  (!col[key]?.locationPlacement || !col[key]?.locationType || !col[key]?.subLocation)
                ) {
                  hasErrors = true;
                  if (!col[key]?.locationType) {
                    set(fieldError, `[${key}][${pindex}].locationType`, thisFieldisRequired);
                  }
                  if (!col[key]?.locationPlacement) {
                    set(fieldError, `[${key}][${pindex}].locationPlacement`, thisFieldisRequired);
                  }
                  if (!col[key]?.subLocation) {
                    set(fieldError, `[${key}][${pindex}].subLocation`, thisFieldisRequired);
                  }
                } else if (col?.source?.location?.name === 'Design_Details') {
                  if (['location', 'attribute', 'output'].includes(fieldKey) && !col[key][fieldKey]) {
                    hasErrors = true;
                    set(fieldError, `[${key}][${pindex}][${fieldKey}]`, thisFieldisRequired);
                  } else {
                    set(fieldError, `[${key}][${pindex}][${fieldKey}]`, '');
                  }
                } else if (!col[key][fieldKey] && !['locationType', 'locationPlacement', 'attribute', 'output'].includes(fieldKey)) {
                  hasErrors = true;
                  set(fieldError, `[${key}][${pindex}][${fieldKey}]`, thisFieldisRequired);
                } else if (
                  ['locationType', 'locationPlacement'].includes(fieldKey) &&
                  ['Bill_of_Materials', 'Sample_Information'].includes(col?.source?.location?.name) &&
                  !col[key][fieldKey]
                ) {
                  hasErrors = true;
                  set(fieldError, `[${key}][${pindex}][${fieldKey}]`, thisFieldisRequired);
                } else {
                  set(fieldError, `[${key}][${pindex}][${fieldKey}]`, '');
                }
              });
            }
            break;
          // ... rest of the cases remain the same
        }
      });
    }

    setGlobalErrors((err) => ({ ...err, ...fieldError }));
    return hasErrors;
  };

  const converDropdownData = (allTypeData) => {
    const allData = cloneDeep(allTypeData);
    let filteredData = [];
    let filteredDropdownData = allData?.filter((ele) => ele.type === 'dropdown' && ele.isLable === true);
    const filteredTextData = allData?.filter((ele) => ele.type === 'text' && ele.isLable === false);
    let filteredRadioData = allData?.filter((ele) => ele.type === 'radio-button' && ele.isLable === true);
    const filteredDateData = allData?.filter((ele) => ele.type === 'date-picker');
    if (!isEmpty(filteredDropdownData)) {
      filteredDropdownData = filteredDropdownData.map((item) => {
        const valuesForLabel = allData.filter((ele) => item._id === ele.lableId);
        item.options = valuesForLabel;
        return item;
      });
    }
    if (!isEmpty(filteredRadioData)) {
      filteredRadioData = filteredRadioData.map((item) => {
        const valuesForLabel = allData.filter((ele) => item._id === ele.lableId);
        item.options = valuesForLabel;
        return item;
      });
    }
    if (isArray(filteredDropdownData) && isArray(filteredTextData)) {
      filteredData = filteredDropdownData.concat(filteredTextData);
    }
    if (isArray(filteredRadioData)) filteredData = filteredData.concat(filteredRadioData);
    if (isArray(filteredDateData)) filteredData = filteredData.concat(filteredDateData);
    return filteredData;
  };

  useEffect(() => {
    dispatch(action.getAllCustomAttributes());
    dispatch(action.getAllMeasurment());
    dispatch(action.getSampleTrackingDates());
  }, [dispatch]);

  const contextValue = useMemo(
    () => ({
      customColumnState,
      setCustomColumnState,
      staticCalcObj,
      checkValidation,
      setGlobalErrors,
      globalError,
      converDropdownData,
      ecomApiCall,
    }),
    [customColumnState, setCustomColumnState, staticCalcObj, checkValidation, setGlobalErrors, globalError, converDropdownData, ecomApiCall],
  );

  return (
    <StateContext.Provider
      value={{
        ...contextValue,
      }}
    >
      {children}
    </StateContext.Provider>
  );
}

export function useCustomColumnState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the CustomColumnContextProvider');
  }
  return context;
}
